import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { createRootRoute, Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/router-devtools"
import { Suspense } from "react"

import { ErrorBoundary } from "@/app/error-boundary"
import { queryClient } from "@/app/query-client"
import { SignalRProvider } from "@/app/signalr-provider"
import { PwaUpdatePrompt } from "@/components/feedback/PwaUpdatePrompt"
import { ToastViewport } from "@/components/feedback/Toast"

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SignalRProvider>
          <Suspense fallback={<div className="p-6 text-ok-foreground-muted">Yükleniyor…</div>}>
            <Outlet />
          </Suspense>
        </SignalRProvider>
        <ToastViewport />
        <PwaUpdatePrompt />
        {import.meta.env.DEV && (
          <>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            <TanStackRouterDevtools position="bottom-left" />
          </>
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
